"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
require("../../styles/components/button.scss");
/**
 * Button component that provides consistent styling and behavior
 * @param props - ButtonProps
 * @returns Button component
 */
const Button = (_a) => {
    var { variant = 'primary', size = 'medium', loading = false, fullWidth = false, disabled = false, className = '', children } = _a, rest = __rest(_a, ["variant", "size", "loading", "fullWidth", "disabled", "className", "children"]);
    const buttonClasses = [
        'button',
        `button--${variant}`,
        size !== 'medium' && `button--${size}`,
        fullWidth && 'button--fullWidth',
        loading && 'button--loading',
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return ((0, jsx_runtime_1.jsxs)("button", Object.assign({ className: buttonClasses, disabled: disabled || loading }, rest, { children: [loading && ((0, jsx_runtime_1.jsx)("span", { className: "button__spinner", "aria-hidden": "true", children: (0, jsx_runtime_1.jsx)("svg", { className: "spinner", viewBox: "0 0 50 50", children: (0, jsx_runtime_1.jsx)("circle", { className: "spinner__path", cx: "25", cy: "25", r: "20", fill: "none", strokeWidth: "5" }) }) })), (0, jsx_runtime_1.jsx)("span", { className: loading ? 'button__content--hidden' : 'button__content', children: children })] })));
};
exports.Button = Button;
exports.default = exports.Button;
